import React, {FC} from 'react';

export const TooltipOverflowCondition: FC = (props) => <>{props.children}</>;
